"use strict";
var $dyn;
(function ($dyn) {
    var serverForm;
    (function (serverForm) {
        var ModelManager;
        (function (ModelManager) {
            ModelManager.models = {};
            ModelManager.collections = {};
            ModelManager.loadDirection = $dyn.ui.ScrollDirection.none;
            ModelManager.activeRootId = "";
            /**
             * Maintains model tracking id -> version mapping
             */
            ModelManager.modelVersions = {};
            ModelManager.nextId = 0;
            ModelManager.insertedRecordsAbove = false;
            ModelManager._validTrackingIdCounter = 1;
            ModelManager._validTrackingIdPrefix = "_trackingId_";
            /**
             * version maintains the current modelupdate count.This gets incremented when we receive a interactions from server. Individual models use this
             * to represent the versioning on client (similar to recversion concept).
             */
            ModelManager.version = 1;
            function trackModel(model, formId) {
                if (!model) {
                    return;
                }
                if (!model.id) {
                    model.id = (ModelManager.nextId++).toString();
                }
                var modelId = model.id;
                if (!formId) {
                    // For models not specific to forms, such as ClientMessageLog
                    ModelManager.models[model.id] = model;
                }
                else {
                    if (!ModelManager.models[formId]) {
                        ModelManager.models[formId] = {};
                    }
                    model._formId = formId;
                    if (model.parent && model.parent.UseReactGrid && model.masterTrackingId) {
                        modelId = model.collectionName + "_" + model.masterTrackingId;
                    }
                    var formModels = ModelManager.models[formId];
                    if (!serverForm.isModel(formModels)) {
                        formModels[modelId] = model;
                    }
                }
            }
            ModelManager.trackModel = trackModel;
            function trackModelCollection(collection, formId) {
                if (!collection) {
                    return;
                }
                if (!collection.id) {
                    collection.id = (ModelManager.nextId++).toString();
                }
                if (!formId) {
                    // For collections not specific to forms, such as ClientMessageLog
                    ModelManager.collections[collection.id] = collection;
                }
                else {
                    if (!ModelManager.collections[formId]) {
                        ModelManager.collections[formId] = {};
                    }
                    collection._formId = formId;
                    var formCollections = ModelManager.collections[formId];
                    if (!serverForm.isModelCollection(formCollections)) {
                        formCollections[collection.id] = collection;
                    }
                }
            }
            ModelManager.trackModelCollection = trackModelCollection;
            function getModel(id, formId) {
                if (!id) {
                    return;
                }
                if (serverForm.isModel(ModelManager.models[id])) {
                    // For models not specific to forms, such as ClientMessageLog
                    return ModelManager.models[id];
                }
                if (formId) {
                    var formModels = ModelManager.models[formId];
                    if (formModels && !serverForm.isModel(formModels)) {
                        return formModels[id];
                    }
                }
                else {
                    var formIds = Object.keys(ModelManager.models);
                    var len = formIds.length;
                    for (var i = len - 1; i >= 0; i--) {
                        // Iterate from the form with largest Id. Most likely this is the top-level form that contains the model we are looking for
                        var formModels = ModelManager.models[formIds[i]];
                        if (formModels && !serverForm.isModel(formModels) && formModels[id]) {
                            return formModels[id];
                        }
                    }
                }
            }
            ModelManager.getModel = getModel;
            function getModelCollection(id, formId) {
                if (!id) {
                    return;
                }
                if (serverForm.isModelCollection(ModelManager.collections[id])) {
                    // For collections not specific to forms, such as ClientMessageLog
                    return ModelManager.collections[id];
                }
                if (formId) {
                    var formCollections = ModelManager.collections[formId];
                    if (!serverForm.isModelCollection(formCollections)) {
                        return formCollections[id];
                    }
                }
                else {
                    var formIds = Object.keys(ModelManager.collections);
                    var len = formIds.length;
                    for (var i = len - 1; i >= 0; i--) {
                        // Iterate from the form with largest Id. Most likely this is the top-level form that contains the model collection we are looking for
                        var formCollections = ModelManager.collections[formIds[i]];
                        if (!serverForm.isModelCollection(formCollections) && formCollections[id]) {
                            return formCollections[id];
                        }
                    }
                }
            }
            ModelManager.getModelCollection = getModelCollection;
            function deleteModel(id, formId) {
                var formModels = ModelManager.models[formId];
                if (formModels && formModels[id]) {
                    delete formModels[id];
                    return true;
                }
                return false;
            }
            ModelManager.deleteModel = deleteModel;
            function removeFormModelsAndCollections(formId) {
                var formModels = ModelManager.models[formId];
                if (formModels) {
                    // tslint:disable-next-line: forin
                    for (var modelKey in formModels) {
                        var model = formModels[modelKey];
                        if (model && model._propertyChangedHost) {
                            model._propertyChangedHost.clear();
                        }
                    }
                    delete ModelManager.models[formId];
                }
                var formCollections = ModelManager.collections[formId];
                if (!serverForm.isModelCollection(formCollections)) {
                    for (var mcKey in formCollections) {
                        if (formCollections[mcKey]) {
                            var mc = formCollections[mcKey];
                            mc._itemsChangedHost && mc._itemsChangedHost.clear();
                            mc.onClear && mc.onClear.clear();
                        }
                    }
                }
                delete ModelManager.collections[formId];
                delete ModelManager.modelVersions[formId];
            }
            ModelManager.removeFormModelsAndCollections = removeFormModelsAndCollections;
            function _updateVersion() {
                ModelManager.version++;
            }
            ModelManager._updateVersion = _updateVersion;
            function getLastVersion() {
                return ModelManager.version;
            }
            ModelManager.getLastVersion = getLastVersion;
            function isValidTrackingId(trackingId) {
                // Tracking id that is null or undefined or equal to 0 or 0-like value is considered to be invalid
                return trackingId && trackingId !== "0";
            }
            ModelManager.isValidTrackingId = isValidTrackingId;
            function generateValidTrackingId() {
                var validTrackingId = ModelManager._validTrackingIdPrefix + ModelManager._validTrackingIdCounter;
                ModelManager._validTrackingIdCounter++;
                return validTrackingId;
            }
            ModelManager.generateValidTrackingId = generateValidTrackingId;
        })(ModelManager = serverForm.ModelManager || (serverForm.ModelManager = {}));
    })(serverForm = $dyn.serverForm || ($dyn.serverForm = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ModelManager.js.map
